export default __webpack_public_path__ + "static/media/token pack.022dca8e.png";